<template>
  <div class="home">
    <div class="header">
      <a class="logo" href="/">
        <img src="../assets/img/logo.png" alt />
        <div class="text">
          Fake Twitter
          <br />
          NFT Avatar Maker
        </div>
      </a>
      <div class="author">
        <a href="https://thuscn.com/lab/" target="_blank">
          by
          <div class="author-name">
            <svg
              width="85"
              height="24"
              viewBox="0 0 412 115"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M57.5 39.2H37.6V93H22V39.2H2V28.1H57.5V39.2ZM112.573 93H97.9727V59.2C97.9727 56.5333 97.506 54.7667 96.5727 53.9C95.706 53.0333 93.5727 52.6 90.1727 52.6C85.9727 52.6 83.306 53.0333 82.1727 53.9C81.0393 54.7 80.4727 56.4667 80.4727 59.2V93H65.8727V23H80.4727V50.5C81.406 45.9 86.506 43.6 95.7727 43.6C102.173 43.6 106.573 44.7667 108.973 47.1C111.373 49.3667 112.573 52.8333 112.573 57.5V93ZM172.045 93H157.645V87.1C156.512 91.7 151.345 94 142.145 94C135.745 94 131.345 92.8667 128.945 90.6C126.545 88.2667 125.345 84.7667 125.345 80.1V44.6H139.945V78.1C139.945 80.7667 140.379 82.5667 141.245 83.5C142.179 84.4333 144.345 84.9 147.745 84.9C151.945 84.9 154.612 84.4667 155.745 83.6C156.879 82.6667 157.445 80.8333 157.445 78.1V44.6H172.045V93ZM226.518 74.1V80.2C226.518 82.6 226.051 84.6667 225.118 86.4C224.251 88.1333 223.118 89.5 221.718 90.5C220.385 91.4333 218.618 92.1667 216.418 92.7C214.218 93.2333 212.085 93.5667 210.018 93.7C208.018 93.9 205.651 94 202.918 94C197.651 94 191.285 93.5 183.818 92.5V82.8C193.085 84.2 199.518 84.9 203.118 84.9C205.985 84.9 208.185 84.6333 209.718 84.1C211.318 83.5 212.118 82.3667 212.118 80.7V77.7C212.118 76.1667 211.685 75.0333 210.818 74.3C209.951 73.5 208.085 73.1 205.218 73.1H198.918C193.851 73.1 189.885 72.1 187.018 70.1C184.218 68.0333 182.818 65.0333 182.818 61.1V55.2C182.818 50.8 184.918 47.7667 189.118 46.1C193.318 44.4333 199.251 43.6 206.918 43.6C210.118 43.6 215.851 43.9 224.118 44.5V53.8C213.718 53 207.851 52.6 206.518 52.6C202.451 52.6 199.885 52.9 198.818 53.5C197.751 54.0333 197.218 55.1 197.218 56.7V59.3C197.218 60.1 197.618 60.8333 198.418 61.5C199.285 62.1667 200.585 62.5 202.318 62.5H208.718C220.585 62.5 226.518 66.3667 226.518 74.1Z"
                fill="#333"
              />
              <path
                d="M290.5 93H243V28.1H258.6V81.9H290.5V93ZM344.008 93H329.708V88.6C328.641 90.5333 327.108 91.9333 325.108 92.8C323.108 93.6 319.441 94 314.108 94C307.574 94 303.241 93 301.108 91C298.974 89 297.908 84.8333 297.908 78.5C297.908 72.7667 299.008 68.8 301.208 66.6C303.408 64.3333 307.341 63.2 313.008 63.2H329.408V59.9C329.408 56.9667 328.708 55.0333 327.308 54.1C325.974 53.1 323.108 52.6 318.708 52.6C314.574 52.6 308.908 53 301.708 53.8V44.6C307.241 43.9333 313.408 43.6 320.208 43.6C329.141 43.6 335.341 44.7 338.808 46.9C342.274 49.0333 344.008 53.3 344.008 59.7V93ZM329.408 80.6V71.2H319.408C316.208 71.2 314.208 71.5667 313.408 72.3C312.608 73.0333 312.208 75 312.208 78.2C312.208 81.3333 312.608 83.2333 313.408 83.9C314.274 84.5667 316.408 84.9 319.808 84.9C321.474 84.9 322.708 84.9 323.508 84.9C324.308 84.8333 325.174 84.7333 326.108 84.6C327.041 84.4667 327.674 84.2667 328.008 84C328.408 83.6667 328.741 83.2333 329.008 82.7C329.274 82.1667 329.408 81.4667 329.408 80.6ZM406.453 59.9V75.8C406.453 82.4 404.453 87.1 400.453 89.9C396.52 92.6333 390.153 94 381.353 94C372.086 94 365.686 92.5667 362.153 89.7C358.62 86.7667 356.853 82.1333 356.853 75.8V23H371.453V49.4C372.32 47.2 373.92 45.7 376.253 44.9C378.653 44.0333 382.286 43.6 387.153 43.6C391.286 43.6 394.653 43.9333 397.253 44.6C399.853 45.2667 401.82 46.3667 403.153 47.9C404.486 49.3667 405.353 51 405.753 52.8C406.22 54.6 406.453 56.9667 406.453 59.9ZM391.853 77.7V59.8C391.853 56.6667 391.253 54.7 390.053 53.9C388.92 53.0333 386.053 52.6 381.453 52.6C377.32 52.6 374.62 53.1333 373.353 54.2C372.086 55.2667 371.453 57.1333 371.453 59.8V77.7C371.453 80.5667 372.053 82.5 373.253 83.5C374.52 84.4333 377.286 84.9 381.553 84.9C385.82 84.9 388.586 84.4333 389.853 83.5C391.186 82.5 391.853 80.5667 391.853 77.7Z"
                fill="#333"
              />
            </svg>
          </div>
        </a>
      </div>
    </div>

    <div class="avatar-maker">
      <div class="twitter-search">
        <input
          type="text"
          v-model="twitterID"
          placeholder="Enter Your Twitter ID"
        />
      </div>
      <div class="avatars">
        <div class="avatar-item twitter-style">
          <img :src="'https://unavatar.io/twitter/' + twitterID" alt="" />
        </div>
        <div class="avatar-item nft-style" id="NFTavatar">
          <div  class="img">
            <img :src="'https://unavatar.io/twitter/' + twitterID" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="download">
      <button class="download-btn" @click="generatorImageDialog" v-if="Mobile">
        🎉 Download
      </button>
      <button class="download-btn" @click="generatorImage" v-else>
        🎉 Download
      </button>
    </div>

    <div class="footer">
      <div class="cell">
        <a href="https://twitter.com/lvwzhen" target="_black">❤️ Follow me</a>
      </div>
      <div class="cell">
        <a href="https://lvwzhen.com" target="_black">🚀 Contact me</a>
      </div>
    </div>

    <van-dialog
      v-model="NFTavatarDialog"
      class="NFTavatar-dialog"
      show-cancel-button
      cancelButtonText="Close"
      :showConfirmButton="false"
    >
      <div class="NFTavatar-pic">
        <img :src="output" />
        <div class="tips">Long press to save the picture</div>
      </div>
    </van-dialog>

    <!-- producthunt -->
    <div class="producthunt">
      <a
        href="https://www.producthunt.com/posts/fake-twitter-nft-avatar-maker?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-fake-twitter-nft-avatar-maker"
        target="_blank"
        ><img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=327671&theme=light"
          alt="Fake Twitter NFT Avatar Maker - Fake Twitter NFT Avatar Maker | Product Hunt"
          style="width: 250px; height: 54px"
          width="250"
          height="54"
      /></a>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import Vue from "vue";
import "vant/lib/toast/style";
import "vant/lib/dialog/style";
import fitty from "fitty";
import domtoimage from "dom-to-image";
Vue.use(Toast);
Vue.use(Dialog);
export default {
  data() {
    return {
      twitterID: "",
      showText: true,
      showImage: false,
      NFTavatarImg: null,
      output: null,
      logoFont: "Quicksand",
      fonts: [
        "Quicksand",
        "Roboto",
        "Dela Gothic One",
        "Lato",
        "Zilla Slab Highlight",
        "Oswald",
        "Lora",
        "Inter",
        "Noto Sans SC",
        "Noto Serif SC",
      ],
      NFTavatarBg: "#FF6700",
      NFTavatarText: "MI",
      NFTavatarDialog: false,
      NFTavatarLogo: "",
      previewImage: null,
      Mobile: false,
      disabled: true,
      hue: 50,
      color: "",
      logoBgColor: "",
      message: "https://twitter-nft.lvwzhen.com",
      NFTavatarUrl:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwCAYAAAA+VemSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKuSURBVHgB7dMBDQAgDMCwg3/PcBtLWg89bw2QdAfIEhjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGMIEhTGAIExjCBIYwgSFMYAgTGMIEhjCBIUxgCBMYwgSGsA/MRAXc/BABqAAAAABJRU5ErkJggg==",
    };
  },
  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },
    changeStyle(e) {
      this.NFTavatarText = e.target.title;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    clearImage() {
      this.showImage = false;
      this.showText = true;
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        this.showImage = true;
        this.showText = false;
      };
    },
    pickFont(font) {
      this.logoFont = font.target.value;
      fitty.fitAll();
    },
    maker() {
      var node = document.getElementById("NFTavatar");
      var that = this;
      const scale = 3;
      const style = {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      };
      const param = {
        height: node.offsetHeight * scale,
        width: node.offsetWidth * scale,
        quality: 1,
        style,
      };
      domtoimage
        .toPng(node,param)
        .then(function (dataUrl) {
          that.output = dataUrl;
        })
        .catch(function () {});
    },
    generatorImageDialog() {
      Toast.loading({
        message: "Loading...",
        forbidClick: true,
      });
      setTimeout(() => {
        Toast.clear;
      }, 300);
      this.maker();
      setTimeout(() => {
        this.NFTavatarDialog = true;
      }, 1000);
    },
    downloadImage(imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = name || "photo";
        a.href = url;
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    },
    generatorImage() {
      Toast.loading({
        message: "Loading...",
        forbidClick: true,
      });
      setTimeout(() => {
        Toast.clear;
      }, 300);
      var that = this;
      var node = document.getElementById("NFTavatar");
      const scale = 3;
      const style = {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      };
      const param = {
        height: node.offsetHeight * scale,
        width: node.offsetWidth * scale,
        quality: 1,
        style,
      };
      domtoimage.toPng(node, param).then(function (res) {
        that.downloadImage(res, "avatar.png");
      });
    },
  },
  mounted() {
    fitty("#my-element", {
      minSize: 12,
      maxSize: 150,
    });
    if (this.isMobile()) {
      this.Mobile = true;
    } else {
      this.Mobile = false;
    }
  },
};
</script>
<style>
@import "~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css";
</style>
<style>
.van-uploader__preview-image {
  width: 216px;
  height: 216px;
}
</style>